angular.module('app').directive('animateOnChange', function($animate, $timeout) {
	return function(scope, elem, attr) {
		scope.$watch(attr.animateOnChange, function(nv, ov) {
			var c = nv ? 'ng-enter' : 'ng-leave';
			$animate.addClass(elem, c).then(function() {
				$timeout(function() {
					$animate.removeClass(elem, c);
				});
			});
		});
	};
});
